// models
import { newNationOptions } from 'constants/selectOptions';
import { UserRole, UserStatusEnum } from 'enums';

// modules
import { type IUserRegister, persistAtom, type UserCombinedInfo } from 'modules';

// libraries
import { atom } from 'recoil';

/** 로그인한 사용자 ID */
export const UserIdAtom = atom<string | null>({
  key: 'UserIdAtom',
  default: null,
  effects_UNSTABLE: [persistAtom]
});

/** 로그인한 사용자 권한 */
export const UserRolesAtom = atom<UserRole | null>({
  key: 'UserRolesAtom',
  default: null,
  effects_UNSTABLE: [persistAtom]
});

/** 로그인한 사용자 정보 */
export const UserInfoAtom = atom<UserCombinedInfo | undefined>({
  key: 'UserInfoAtom',
  default: undefined,
  effects_UNSTABLE: [persistAtom]
});

/** 관리자가 관리자 등록 정보 */
export const RegisterManagerAtom = atom<IUserRegister>({
  key: 'RegisterManagerAtom',
  default: {
    mobileNationId: newNationOptions[0].value,
    fullName: '',
    mobile: '',
    nationId: '',
    companyId: '',
    designationId: '',
    status: UserStatusEnum.USING,
    role: UserRole.ROLE_WORKER,
    hsseInduction: null,
    mobilization: '',
    passportAssign: 'YET',
    dateOfBirth: null,
    email: '',
    directIndirect: '',
    frsId: '',
    yearsOfExperience: '',
    psacNo: ''
  }
});
